import styled from "styled-components";
import { Field } from "@zendeskgarden/react-forms";

export const SelectContainer = styled(Field)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
